const Cookies = require('cookies-js');

export const setCookie = (key, value, durationInSeconds) => {
  Cookies.set(key, value, {expires: durationInSeconds});
}

export const getCookie = (key) => {
  return Cookies.get(key);
}

export const setCookieYear = (key, value) => {
  const afterOneYear = new Date(new Date().setFullYear(new Date().getFullYear() + 1));
  Cookies.set(key, value, {expires: afterOneYear});
}

export const removeCookie = (key) => {
  Cookies.expire(key);
}